var _path;
import * as React from "react";
function SvgPlug(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5.5a1.5 1.5 0 10-3 0V11h3V5.5zm-12 0a1.5 1.5 0 10-3 0V11h3V5.5zM31 13H9a1 1 0 00-1 1v1a1 1 0 001 1h1v4c0 5.009 3.694 9.12 8.5 9.849V36h3v-6.151C26.306 29.12 30 25.009 30 20v-4h1a1 1 0 001-1v-1a1 1 0 00-1-1zm-4 7a7 7 0 11-14 0v-4h14v4z"
  })));
}
export default SvgPlug;